export default __webpack_public_path__ + "21c77608759057941fe7150a654f402c.png";